/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import { YayasanLoyolaService } from '@api/services';
import PropTypes from 'prop-types';

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';
import Header from '../Header';
import Footer from '../Footer';
import { notification } from 'antd';

export default function Layout({ children }) {
  const [dataAll, setdataAll] = useState([]);
  const [logoLoyola, setLogoLoyola] = useState({ source: null });
  const [logoBidikti, setLogoBidikti] = useState({ source: null });

  useStyles(s, normalizeCss);
  useEffect(() => {
    YayasanLoyolaService.portalYayasanheaderFooter(children.props.language).then(res => {
      // alert(res);
      const { data, rc, message } = res.data;
      if(rc == "00"){
        setdataAll(data);
        setLogoLoyola({ source: data.hfLogoPath });
        setLogoBidikti({ source: data.hfLogoPath });
      }else{
        notification.error({
          placement: 'bottomRight',
          message: label.notifikasi.error.message,
          description: message ? message : res.message ? res.message : 'Terjadi Kesalahan pada Server',
        });
      }
    });
  }, []);

  const dataHeaderFooter = dataAll;
  return (
    <div id='dropdownNav'>
      <Header
        dataHeaderFooter={dataHeaderFooter}
        logoLoyola={logoLoyola}
        logoBidikti={logoBidikti}
        props={children.props}
      />
      {children}
      {/* <Feedback /> */}
      <Footer
        dataHeaderFooter={dataHeaderFooter}
        logoLoyola={logoLoyola}
        logoBidikti={logoBidikti}
        props={children.props}
      />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
